let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bnotA")).then(() => parcelRequire('7BQsk'));